import { Navigate, NavigateProps, useLocation } from "react-router-dom";

interface NavigateWithSearchParamsProps extends NavigateProps {
  to: string;
}

const NavigateWithSearchParams = (props: NavigateWithSearchParamsProps) => {
  const location = useLocation();
  const { to, state: callerState, ...rest } = props;

  return (
    <Navigate
      to={to + location.search}
      {...rest}
      state={{
        ...callerState,
        from: {
          pathname: location?.pathname,
          search: location?.search ?? "",
        },
      }}
    />
  );
};

export default NavigateWithSearchParams;
